import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Backend from "./backend.js";
var Canvas = /*#__PURE__*/function (_Backend) {
  _inherits(Canvas, _Backend);
  var _super = _createSuper(Canvas);
  function Canvas() {
    var _this;
    _classCallCheck(this, Canvas);
    _this = _super.call(this);
    _this._ctx = document.createElement("canvas").getContext("2d");
    return _this;
  }
  _createClass(Canvas, [{
    key: "schedule",
    value: function schedule(cb) {
      requestAnimationFrame(cb);
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this._ctx.canvas;
    }
  }, {
    key: "setOptions",
    value: function setOptions(opts) {
      _get(_getPrototypeOf(Canvas.prototype), "setOptions", this).call(this, opts);
      var style = opts.fontStyle ? "".concat(opts.fontStyle, " ") : "";
      var font = "".concat(style, " ").concat(opts.fontSize, "px ").concat(opts.fontFamily);
      this._ctx.font = font;
      this._updateSize();
      this._ctx.font = font;
      this._ctx.textAlign = "center";
      this._ctx.textBaseline = "middle";
    }
  }, {
    key: "clear",
    value: function clear() {
      this._ctx.fillStyle = this._options.bg;
      this._ctx.fillRect(0, 0, this._ctx.canvas.width, this._ctx.canvas.height);
    }
  }, {
    key: "eventToPosition",
    value: function eventToPosition(x, y) {
      var canvas = this._ctx.canvas;
      var rect = canvas.getBoundingClientRect();
      x -= rect.left;
      y -= rect.top;
      x *= canvas.width / rect.width;
      y *= canvas.height / rect.height;
      if (x < 0 || y < 0 || x >= canvas.width || y >= canvas.height) {
        return [-1, -1];
      }
      return this._normalizedEventToPosition(x, y);
    }
  }]);
  return Canvas;
}(Backend);
export { Canvas as default };